import { render, staticRenderFns } from "./TierUpgradeNoticePanel.vue?vue&type=template&id=9d39b958&"
import script from "./TierUpgradeNoticePanel.vue?vue&type=script&lang=ts&"
export * from "./TierUpgradeNoticePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports